<div class="flex items-center justify-center h-[100%]">
    <button class="si-header-item btn btn-circle btn-ghost" [name]="userName()" [siHeaderDropdownTriggerFor]="account">
        <si-avatar [initials]="userInitials()" [altText]="userName()" [imageUrl]="userPhoto()" />
    </button>

    <ng-template #account>
        <si-header-dropdown>
            <div class="mx-5">
                <div class="si-h5">{{ userName() }}</div>
                <div>{{ userOrgCode() }}</div>
                <div class="d-flex align-items-center text-secondary mt-2">Siemens AG</div>
            </div>
        </si-header-dropdown>
    </ng-template>
</div>
